import { $T } from 'client/library/translation'
import type { FrameMenuItem } from 'app/types'
import type { ServiceInitArgs } from 'app/services/base'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'

export function buildRelationshipAndBoundaryMenu(services: ServiceInitArgs) {
  const { action } = services
  if (!action) {
    return []
  }

  const workbook = useWorkspaceStore().workbook
  if (!workbook) return []

  const menus: FrameMenuItem[] = [
    {
      label: $T('Edit'),
      enable: workbook.getAction('editor.showEditBox').isEnabled,
      action: () => workbook.getAction('editor.showEditBox').execute(),
    },
    {
      label: $T('Delete'),
      enable: workbook.getAction('delete').isEnabled,
      action: () => workbook.getAction('delete').execute(),
    },
    {
      type: 'separator',
    },
    {
      label: $T('Copy Style'),
      enable: workbook.getAction('editor.copyStyle').isEnabled,
      action: () => workbook.getAction('editor.copyStyle').execute(),
    },
    {
      label: $T('Paste Style'),
      enable: workbook.getAction('editor.pasteStyle').isEnabled,
      action: () => workbook.getAction('editor.pasteStyle').execute(),
    },
    {
      label: $T('Reset Style'),
      enable: workbook.getAction('editor.resetStyle').isEnabled,
      action: () => workbook.getAction('editor.resetStyle').execute(),
    },
  ]
  return menus
}
